import { ProjectRelationModel } from "../../../../hub_schema/hubTypes";

export class RelationsContainerBase {
    protected isVerified(relation: ProjectRelationModel, backwardRelations: ProjectRelationModel[], primary): boolean {
        return backwardRelations.some(br => br.projectId === relation.relatedProjectId && (primary ? br.isPrimary : !br.isPrimary));
    }
}